import { log } from "@/utils/common";
import { DELIVERY_FEE_SKU, PACKAGE_WRAPPING_FEE_SKU } from "@/utils/constants";
import store from "@/store";
import { http } from "@/utils/http";
import packApi from "./pack";
import { from } from "rxjs";
import { distinct } from "rxjs/operators";

const mockPreOrderResult = {
  statusCode: 200,
  result: {
    appliedOrderPromotions: [
      {
        description:
          "MPN 프로모션 테스트 - 장바구니 3만원 이상 구매 시, 쇼핑백 무료 증정",
        promotion: {
          code: "PRM7001",
          couldFireMessages: [],
          description: "MPN 프로모션 테스트 - 쇼핑백 제공",
          endDate: "2020-12-31T10:01:36+0000",
          firedMessages: [],
          promotionType: "규칙 기반 프로모션",
          startDate: "2020-11-02T10:01:34+0000",
        },
      },
    ],
    appliedProductPromotions: ["303674K", "303671K"],
    code: "180-503301598",
    total_price: 360570,
    total_pv: 224400,
    total_bv: 361800,
    product_info: [
      {
        item_sku: "303674K",
        dose_cnt: 210,
        price: 143220,
        pv: 88200,
        bv: 142800,
      },
      {
        item_sku: "303673K",
        dose_cnt: 210,
        price: 89670,
        pv: 56700,
        bv: 90300,
      },
      {
        item_sku: "303672K",
        dose_cnt: 150,
        price: 98250,
        pv: 61500,
        bv: 99000,
      },
      {
        item_sku: "303671K",
        dose_cnt: 90,
        price: 29430,
        pv: 18000,
        bv: 29700,
      },
    ],
    abo_info: {
      name: "ROWENA",
      uid: "7480003",
      accountTypeCode: "AMWAYBUSINESSNATURE_1",
      defaultAddress: {
        formattedAddress: "서울 강서구 강서로45길 31-1 (화곡동)",
        postalCode: "07705",
      },
      mobileArea: "010",
      mobileNumber: "050000268",
      dateOfBirth: "1976-10-31T15:00:00+0000",
      email: "a@dqgp.xgd",
      gender: "MALE",
      isPrimary: "true",
    },
  },
};

const mockDoOrderResult = {
  statusCode: 200,
  result: {},
};

const defaultOrderFailureMessage =
  "처리도중 오류로 결제가 취소되었습니다.\n자세한 사항은 시스템 관리자에 문의 부탁드립니다.";

async function checkOrderLimit() {
  try {
    const result = await http.post("/abo-info", {
      search_type: "P",
    });
    log("checkOrderLimit", result);
    return result.result;
  } catch (e) {
    store.dispatch("newError", {
      msg: "결제 요청 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function checkOrderLimitCount() {
  try {
    const result = await http.post("/abo-info", {
      search_type: "PC",
    });
    log("checkOrderLimitCount", result);
    return result.result;
  } catch (e) {
    store.dispatch("newError", {
      msg: "결제 요청 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

function tryParseMessage(m) {
  try {
    return JSON.parse(JSON.parse(m));
  } catch (e) {
    return m;
  }
}

function tryParseMessageForPreorder(m) {
  try {
    const parsed = JSON.parse(m);
    if (typeof parsed === "object") {
      return parsed;
    }
    try {
      // cart 에러 외의 문제발생시 조치...
      return JSON.parse(JSON.parse(m));
    } catch (e2) {
      return m;
    }
  } catch (e) {
    return m;
  }
}

function validateOrderApiError(e, inspector) {
  let error = e;
  try {
    const m = e.errorMessage.replace(/'/g, '"');
    error = JSON.parse(m);

    let msg = defaultOrderFailureMessage;
    msg = inspector(error.type, error.message, msg);

    store.dispatch("newError", {
      msg,
      error,
    });
  } catch (e2) {
    console.warn("parse Error", e);
    store.dispatch("newError", {
      msg: defaultOrderFailureMessage,
      error,
    });
  }
  return {
    error,
  };
}

function findCartError(o) {
  return o.cartModifications
    .filter((n) => n.statusCode !== "success")
    .reduce((acc, c) => `${acc}\n${c.statusMessage}`, "");
}

function findPaymentError(o) {
  console.warn(o.status, o.statusDisplay, o);
  switch (o.statusDisplay) {
    case "paymentFailed":
      return o.paymentDetails.paymentInfos[0].statusDetails;
    case "orderfailed":
    case "error":
    default:
      return defaultOrderFailureMessage;
  }
}

async function getOrderToken(reqNo, groupOrder, groupProductInfo) {
  try {
    const ssoToken = store.getters["ssoToken"];
    const url = "/order/token";
    const requestBody = {
      req_no: reqNo,
      group_order: groupOrder,
      group_product_info: groupProductInfo,
    };
    const tokenResponse = await http.post(url, requestBody, {
      "Sso-Token": ssoToken,
    });

    return tokenResponse["order_token"];
  } catch (e) {
    console.error(e);
    await store.dispatch("newError", {
      msg: "결제 요청 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function getPreOrderInfo(reqNo, payment_type="") {
  // 주문 토큰
  const orderToken = await getOrderToken(reqNo, false, null);
  log("getPreOrderInfo", orderToken);
  store.commit("order/updateOrderToken", orderToken);

  const check = await checkOrderLimit();
  if (typeof check === "object") {
    return check;
  }

  if (!check) {
    return {
      msg: "월 주문 가능 횟수를 초과했습니다.",
    };
  }

  // 팩 상세 조회
  // 모의해킹 시 이 부분에서 파라미터 변조가 일어났음.
  const r = await packApi.getApplianceDetail(reqNo);
  if (r.error) {
    log("orderApi::getPreOrderInfo", "error", r);
    return r;
  }

  const {
    // eslint-disable-next-line camelcase
    take_days,
    is_first,
    purchase_type, cur_seq, cfm_kind
  } = r.order_info[0];
  const abc_cd = getAbcCd(r.order_info[0])

  const productsDetails = r.order_detail_list.map(n => ({
    item_name: n.item_name,
    item_sku: n.item_sku,
    pockets: n.dose,
    seq: n.dose_list
  }));

  const results = await checkSoldOut("C", productsDetails, abc_cd);

  log("######### checkSoldOut results #########", results);

  const {
    isSoldout,
    soldoutSkus,
    soldoutName,
    isEndOfSale,
    endOfSaleSkus,
    endOfSaleName,
    reOrderble,
    reCalDoseInfo,
  } = results;

  if (isSoldout || isEndOfSale) {
    return {
      orderlist: r,
      isSoldout: isSoldout,
      soldoutSkus: soldoutSkus,
      soldoutName: soldoutName,
      isEndOfSale: isEndOfSale,
      endOfSaleSkus: endOfSaleSkus,
      endOfSaleName: endOfSaleName,
      reOrderble: reOrderble,
      reCalDoseInfo: reCalDoseInfo,
    };
  }

  if (results.error) {
    log("orderApi::checkSoldOut", "error", r);
    return r;
  }

  // 상세 약물 복용 정보
  // eslint-disable-next-line camelcase
  const dose_info = r.order_detail_list.map((n) => ({
    item_sku: n.item_sku,
    dose_cnt: n.dose_list
      .split(",")
      .map((x) => parseInt(x, 10))
      .reduce((acc, cur) => acc + cur, 0),
  }));

  // 포장 갯수 산정
  // const productsCount = dose_info.length;
  const dosePerDay = r.order_detail_list[0].dose;
  // eslint-disable-next-line camelcase
  const totalPackageWraps = dosePerDay * take_days;

  dose_info.push({
    item_sku: PACKAGE_WRAPPING_FEE_SKU,
    dose_cnt: totalPackageWraps,
  });

  const products = store.getters["product/products"];

  // 포장비 계산
  const packageWrapFee =
    products.find((product) => product.item_sku === PACKAGE_WRAPPING_FEE_SKU)
      .price * totalPackageWraps;

  console.log("r ::: ", r);
  console.log("purchase_type ::: ", purchase_type);
  console.log("cur_seq ::: ", cur_seq);
  console.log("cfm_kind ::: ", cfm_kind);
  console.log(
    "is total_price ::: ",
    r.order_info[0].total_price + packageWrapFee
  );

  // 채팅 상담인 경우 배송비 체크, ABC 2회차 주문부터 배송이므로 배송비 체크
  const checkDeleveryFee = (cfm_kind == "VCALL" || (purchase_type == 'recurring' && cfm_kind == "ABC" && cur_seq >= 2));
  if (checkDeleveryFee && r.order_info[0].total_price + packageWrapFee < 60000) {
    dose_info.push({
      item_sku: DELIVERY_FEE_SKU,
      dose_cnt: 1,
    });
  }

  const params = {
    search_type: "I",
    abo_no: store.getters.userId,
    cuid: store.getters.cuid,
    abc_cd,
    dose_info,
    take_days,
    req_no: reqNo,
    payment_type,
    purchase_type
  };

  try {
    // 결제 정보 조회
    const ssoToken = store.getters["ssoToken"]

    const headers = {
      "Sso-Token": ssoToken,
      "Order-Token": orderToken
    }

    const { result } = await http.post("/order/payment", params, headers);
    log("api/order::getPreOrderInfo", result);

    // abc_cd는 직접 주입
    // eslint-disable-next-line camelcase
    result.abc_cd = abc_cd;
    result.appliedOrderPromotions = [];

    // 화상상담에 대한 배달주문 처리
    // result.cfm_kind = r.order_info[0].cfm_kind;
    result.cfm_kind = (purchase_type == 'recurring' && cfm_kind == "ABC" && cur_seq >= 2) ? "VCALL" : cfm_kind;

    // reqNo는 직접 주입
    // eslint-disable-next-line camelcase
    result.reqNo = reqNo;
    result.curSeq = cur_seq;

    if (result.abo_info.defaultAddress.id === undefined) {
      result.abo_info.defaultAddress = {
        "cellphone": "",
        "formattedAddress": "",
        "id": "",
        "name": "",
        "postalCode": "",
        "isDefault": false
      }
    } else {
      result.abo_info.defaultAddress.isDefault = true
    }

    result.product_info.forEach((m, idx) => {
      products.forEach((n) => {
        if (n.item_sku === m.item_sku) {
          result.product_info[idx].seq = n.seq;
        }
      });
    });
    result.product_info.sort((a, b) => a.seq - b.seq);

    return result;
  } catch (e) {
    console.error(399, e)
    log("api/order::getPreOrderInfo", "error", e);
    return validateOrderApiError(e, (type, message, defaultMessage) => {
      switch (type) {
        case "I": {
          const o = tryParseMessageForPreorder(atob(message));
          console.warn(o.status, o);
          // check cart error
          if (o.cartModifications) {
            return findCartError(o);
          }

          return defaultMessage;
        }
        default:
          return defaultMessage;
      }
    });
  }
}

async function getPreOrderInfoForGroup(reqNos) {
  const orderToken = await getOrderToken(
    reqNos[0],
    true,
    reqNos.map((reqNo) => ({ req_no: reqNo }))
  );
  store.commit("order/updateOrderToken", orderToken);
  const checkCount = await checkOrderLimitCount();
  if (typeof checkCount === "object") {
    return checkCount;
  }

  if (parseInt(checkCount) + reqNos.length > 50) {
    return {
      msg: "월 주문 가능 횟수를 초과했습니다.",
    };
  }

  const response = await packApi.getApplianceDetailForGroup(reqNos);
  if (response.error) {
    log("orderApi::getApplianceDetailForGroup", "error", response);
    return response;
  }

  let totalPrice = 0;
  const products = store.getters["product/products"];
  const group_info = [];
  let main_abc_cd;
  let isFirst;
  response.forEach((item, index) => {
    const {
      // eslint-disable-next-line camelcase
      abc_cd,
      take_days,
      req_no,
      mypack_name,
      is_first,
    } = item.order_info[0];

    if (index == 0) {
      main_abc_cd = abc_cd;
      isFirst = is_first;
    }
    // eslint-disable-next-line camelcase
    const dose_info = item.order_detail_list.map((n) => ({
      item_sku: n.item_sku,
      dose_cnt: n.dose_list
        .split(",")
        .map((x) => parseInt(x, 10))
        .reduce((acc, cur) => acc + cur, 0),
    }));

    // 포장 갯수 산정
    // const productsCount = dose_info.length;
    const dosePerDay = item.order_detail_list[0].dose;
    // eslint-disable-next-line camelcase
    const totalPackageWraps = dosePerDay * take_days;

    dose_info.push({
      item_sku: PACKAGE_WRAPPING_FEE_SKU,
      dose_cnt: totalPackageWraps,
    });

    // 포장비 계산
    const packageWrapFee =
      products.find((product) => product.item_sku === PACKAGE_WRAPPING_FEE_SKU)
        .price * totalPackageWraps;
    // 첫주문일 경우 무조건 pickup이기 때문에 배송비는 없음
    // 첫주문이 아닐경우 배송비 측정을 위한 그룹주문의 전체 금액 합산
    if (!item.order_info[0].is_first) {
      totalPrice += item.order_info[0].total_price + packageWrapFee;
    }
    group_info.push({
      req_no,
      mypack_name,
      dose_info,
      take_days,
    });
  });

  // 재주문일경우 ABC_CD는 분당으로 고정
  if (!isFirst) {
    main_abc_cd = "bundang";
  }
  // 전체 합계가 6만원 미만일 경우, 메인 주문에 배송비 추가
  if (!isFirst && totalPrice < 60000) {
    group_info[0].dose_info.push({
      item_sku: DELIVERY_FEE_SKU,
      dose_cnt: 1,
    });
  }

  const params = {
    search_type: "GI",
    abo_no: store.getters.userId,
    cuid: store.getters.cuid,
    abc_cd: main_abc_cd,
    group_info,
  };

  try {
    const ssoToken = store.getters["ssoToken"]
    const headers = {
      "Sso-Token": ssoToken,
      "Order-Token": orderToken
    }

    const { result } = await http.post("/order/payment", params, headers);
    log("api/order::getPreOrderInfo", result);

    if (result.abo_info.defaultAddress.id === undefined) {
      result.abo_info.defaultAddress = {
        "cellphone": "",
        "formattedAddress": "",
        "id": "",
        "name": "",
        "postalCode": "",
        "isDefault": false
      }
    } else {
      result.abo_info.defaultAddress.isDefault = true
    }

    // abc_cd는 직접 주입
    // eslint-disable-next-line camelcase
    result.abc_cd = main_abc_cd;

    // 화상상담에 대한 배달주문 처리
    result.cfm_kind = response[0].order_info[0].cfm_kind;

    // eslint-disable-next-line camelcase
    result.group_product_info.forEach((item) => {
      item.product_info.forEach((m, idx) => {
        products.forEach((n) => {
          if (n.item_sku === m.item_sku) {
            item.product_info[idx].seq = n.seq;
          }
        });
      });

      item.product_info.sort((a, b) => a.seq - b.seq);
    });

    return result;
  } catch (e) {
    log("api/order::getPreOrderInfo", "error", e);
    return validateOrderApiError(e, (type, message, defaultMessage) => {
      switch (type) {
        case "I": {
          const o = tryParseMessageForPreorder(atob(message));
          console.warn(o.status, o);
          // check cart error
          if (o.cartModifications) {
            return findCartError(o);
          }

          return defaultMessage;
        }
        default:
          return defaultMessage;
      }
    });
  }
}

async function doOrder(params) {
  // eslint-disable-next-line no-param-reassign
  params.abo_no = store.getters.userId;
  params.cuid = store.getters.cuid;

  try {
    const orderToken = store.getters["order/orderToken"];
    const ssoToken = store.getters["ssoToken"];

    const headers = {
      "Order-Token": orderToken,
      "Sso-Token": ssoToken,
    };

    const { result, error } = await http.post("/order/payment", params, headers);
    log("api/order::doOrder", result, error);
    return { result, error };
  } catch (e) {
    log("api/order::doOrder", "error", e);
    return validateOrderApiError(e, (type, message, defaultMessage) => {
      switch (type) {
        case "P": {
          const o = tryParseMessage(atob(message));
          console.warn(o.status, o);
          // check cart error
          if (o.cartModifications) {
            return findCartError(o);
          }

          return findPaymentError(o);
        }

        default:
          return defaultMessage;
      }
    });
  }

  // const { result } = await http.mockPost('/order/payment', params, mockDoOrderResult, 500);
}

async function checkAutoWithdrawPassword(password) {
  const params = {
    abo_no: store.getters.userId,
    cuid: store.getters.cuid,
    password,
  };

  try {
    const { result } = await http.post("/order/autopay", params);
    log("api/order::doOrder", result);

    if (result.code === "success") {
      return result;
    }
    return {
      error: result,
    };
  } catch (e) {
    store.dispatch("newError", {
      msg:
        "자동이체 비밀번호 검증 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function getDeliveryList(regularShippingAddressId="") {
  try {
    const { result } = await http.post("/order/address", {
	  ...(regularShippingAddressId && { regularShippingAddressId })// 조건부 추가
    });
    const r = result.addresses.map((n) => ({
      name: n.name,
      defaultAddress: {
        postalCode: n.postalCode,
        formattedAddress: n.formattedAddress,
      },
      id: n.id,
      mobileNumber: n.cellphone.substring(3),
      mobileArea: n.cellphone.substring(0, 3),
      isDefault: n.defaultAddress,
      isRegularShipping: n.regularShippingAddress,
      message: "",
    }));
    return r;
  } catch (e) {
    store.dispatch("newError", {
      msg:
        "배송지 목록 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function cancelPayment(orderKey) {
  try {
    const ssoToken = store.getters["ssoToken"]
    const headers = {
      "Sso-Token": ssoToken
    }
    const { result } = await http.post("/order/cancel", {
      search_type: "P",
      abo_no: store.getters.userId,
      cuid: store.getters.cuid,
      order_key: orderKey,
    }, headers);
    console.log(result);
    return result;
  } catch (e) {
    store.dispatch("newError", {
      msg: "결제취소 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function changeDeliveryDestination(delivery) {
  try {
    const result = await http.post("/abo-info", {
      search_type: "D",
      id: delivery.id,
      order_key: delivery.order_key,
      recv_name: delivery.name,
      recv_phone: delivery.mobileArea + delivery.mobileNumber,
      zip: delivery.defaultAddress.postalCode,
      addr: delivery.defaultAddress.formattedAddress,
    });

    if (result.statusCode === 500) {
      store.dispatch("newError", {
        msg: result.result,
        error: result,
      });
      return {
        error: result.result,
      };
    }

    return result;
  } catch (e) {
    store.dispatch("newError", {
      msg: "배송지 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

// 결제수단 변경 이벤트
async function changePaymentMethod(orderKey, paymentMethod, groupOrderYn) {
  try {
    log("OrderAPI::ChangePaymentmethod", paymentMethod);

    const orderToken = store.getters["order/orderToken"];
    const ssoToken = store.getters["ssoToken"];

    const headers = {
      "Sso-Token": ssoToken,
      "Order-Token": orderToken,
    };

    const { result } = await http.post(
      "/order/payment",
      {
        search_type: "PS",
        abo_no: store.getters.userId,
        cuid: store.getters.cuid,
        code: orderKey,
        paymentModeCode: paymentMethod,
        group_order_yn: groupOrderYn,
      },
      headers
    );

    return result;
  } catch (e) {
    store.dispatch("newError", {
      msg: "결제수단 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}


/*
  orderInfo = {
    purchase_type: this.purchaseType,
    cur_seq: this.curSeq,
    abc_cd: this.abcCd
  }
*/
function getAbcCd(orderInfo) {
  const { purchase_type, cur_seq, abc_cd } = orderInfo;
  let abcCd = "";

  if (purchase_type == 'recurring' && cur_seq > 1) {
    abcCd = "bundang"
  } else {
    abcCd = abc_cd;
  }
  log("getAbcCd :: abcCd", abcCd);
  return abcCd;
}

// 품절제품 체크
/*
  productsDetails = r.order_detail_list.map(n => ({
    item_name: n.item_name,
    item_sku: n.item_sku,
    pockets: n.dose,
    seq: n.dose_list
  }));
*/
async function checkSoldOut(type, productsDetails, abcCd) {
  try {
    const { results } = await http.post("/order/soldout", {
      abo_no: store.getters.userId,
      cuid: store.getters.cuid,
      productsDetails: productsDetails,
      type: type,
      abcCd: abcCd,
    });
    return results;
  } catch (e) {
    store.dispatch("newError", {
      msg: "품절제품 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

// 품절제품 제거
async function removeSoldOut(type, sku, req_no) {
  try {
    const { results } = await http.post("/order/soldout", {
      abo_no: store.getters.userId,
      cuid: store.getters.cuid,
      req_no: req_no,
      sku: sku,
      type: type,
    });
    return results;
  } catch (e) {
    store.dispatch("newError", {
      msg:
        "품절제품을 주문서에서 제거 중에 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function getAmwayPayMethods() {
  try {
    const apiResponse = await http.post("/order/a-pay/methods");
    log("GetAmwayPayMethods: ", apiResponse);
    if (apiResponse.error) {
      await store.dispatch("newError", {
        msg: "A-Pay 결제수단을 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.",
        error: apiResponse.error,
      });
      return {
        error: apiResponse.error,
      };
    }

    store.commit(
      "amwaypay/updateAmwayPayAccountStoreId",
      apiResponse.accounts.storeId
    );
    store.commit(
      "amwaypay/updateAmwayPayCardStoreId",
      apiResponse.cards.storeId
    );

    const customerInfo = apiResponse.customerInfo;
    const masterCustomerId = customerInfo.masterParty.customerId;
    const masterCustomerName = customerInfo.masterParty.customerName;

    log("GetAmwayPayMethod", masterCustomerName);

    const subCustomerId = customerInfo.subParty
      ? customerInfo.subParty.customerId
      : "";
    const subCustomerName = customerInfo.subParty
      ? customerInfo.subParty.customerName
      : "";

    store.commit("amwaypay/updateMasterName", masterCustomerName);
    store.commit("amwaypay/updateSubName", subCustomerName);

    const initialParty = customerInfo.masterParty.isDefault ? 0 : 1;

    store.commit("amwaypay/updateSelectedParty", initialParty);

    const defaultAccount = apiResponse.accounts.defaultPay;
    const masterAccounts = apiResponse.accounts.masterParty
      ? apiResponse.accounts.masterParty
      : [];
    const subAccounts = apiResponse.accounts.subParty
      ? apiResponse.accounts.subParty
      : [];

    const defaultCard = apiResponse.cards.defaultPay;
    const masterCards = apiResponse.cards.masterParty
      ? apiResponse.cards.masterParty
      : [];
    const subCards = apiResponse.cards.subParty
      ? apiResponse.cards.subParty
      : [];

    const uniqueMasterAccounts = [];
    from(
      defaultAccount
        .filter((account) => account.customerId === masterCustomerId)
        .concat(masterAccounts)
    )
      .pipe(distinct((account) => account.id))
      .subscribe((account) => {
        uniqueMasterAccounts.push(account);
      });

    const uniqueMasterCards = [];
    from(
      defaultCard
        .filter((account) => account.customerId === masterCustomerId)
        .concat(masterCards)
    )
      .pipe(distinct((card) => card.id))
      .subscribe((card) => {
        uniqueMasterCards.push(card);
      });

    const uniqueSubAccounts = [];
    from(
      defaultAccount
        .filter((account) => account.customerId === subCustomerId)
        .concat(subAccounts)
    )
      .pipe(distinct((account) => account.id))
      .subscribe((account) => {
        uniqueSubAccounts.push(account);
      });

    const uniqueSubCards = [];
    from(
      defaultCard
        .filter((account) => account.customerId === subCustomerId)
        .concat(subCards)
    )
      .pipe(distinct((card) => card.id))
      .subscribe((card) => {
        uniqueSubCards.push(card);
      });

    return {
      accounts: {
        defaultPay: [...defaultAccount],
        masterParty: [...uniqueMasterAccounts],
        subParty: [...uniqueSubAccounts],
        storeId: apiResponse.accounts.storeId,
      },
      cards: {
        defaultPay: [...defaultCard],
        masterParty: [...uniqueMasterCards],
        subParty: [...uniqueSubCards],
        storeId: apiResponse.cards.storeId,
      },
    };
  } catch (e) {
    log("GetApayMethods Error: ", e);
    await store.dispatch("newError", {
      msg: "A-Pay 결제수단을 불러올 수 없습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      accounts: {
        defaultPay: [],
        masterParty: [],
        subParty: [],
        storeId: "cp_amwayaccount",
      },
      cards: {
        defaultPay: [],
        masterParty: [],
        subParty: [],
        storeId: "cp_amwaypay",
      },
    };
  }
}

async function getAmwayPayClientKey() {
  const url = "/order/a-pay/client-key";
  const response = await http.get(url);
  log("GetAmwayPayClientKey: ", response);
  if (response.error) {
    await store.dispatch("newError", {
      msg: "A-Pay 키 조회 중 에러가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: response.error,
    });
    return {
      error: response.error,
    };
  }

  return response;
}

async function requestPayment(postData = {}) {
  const url = "/order/a-pay";

  const orderToken = store.getters["order/orderToken"];
  const ssoToken = store.getters["ssoToken"];

  const headers = {
    "Sso-Token": ssoToken,
    "Order-Token": orderToken,
  };

  const response = await http.post(url, postData, headers);

  log("RequestPayment::", response);
  if (response.error) {
    // await store.dispatch('newError', {
    //   msg: "A-Pay 결제 도중 에러가 발생했습니다. 잠시 후 다시 시도해 주세요.",
    //   error: response.error,
    // });
    return {
      error: response.error,
    };
  }

  return response;
}

async function getPaymentConfig(params) {
  try {
    const { result } = await http.post("/payment-config/info", params);
    return result;
  } catch (e) {
    store.dispatch("newError", {
      msg:
        "빌링키 정보 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function getBillingKeyInfo(uuid) {
  try {
    const { result } = await http.post("/billing-key/info", {
      id: uuid,
    });
    return result;
  } catch (e) {
    store.dispatch("newError", {
      msg:
        "빌링키 정보 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function getAboPhone() {
  try {
    const { result } = await http.post("/abo-info", {
      search_type: "MN",
    });
    log("getAboPhone", result);
    return result;
  } catch (e) {
    store.dispatch("newError", {
      msg: "회원정보 조회 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function placeOrder(reqNo) {

  const orderToken = await getOrderToken(reqNo, false, null);
  log("getPreOrderInfo", orderToken);
  store.commit("order/updateOrderToken", orderToken);

  try {
    const ssoToken = store.getters["ssoToken"]
    const headers = {
      "Sso-Token": ssoToken,
      "Order-Token": orderToken
    }

    const { result, error } = await http.post("/order/checkout", {
      req_no: reqNo,
      abo_no: store.getters.userId,
    }, headers);
    log("api/order::placeOrder", result, error);
    return { result, error };
  } catch (e) {
    console.log("api/order::placeOrder", "error", e);
    return {
      error: e,
    };
    //   return validateOrderApiError(e, (type, message, defaultMessage) => {
    //     switch (type) {
    //       case "I": {
    //         const o = tryParseMessageForPreorder(atob(message));
    //         console.warn(o.status, o);
    //         // check cart error
    //         if (o.cartModifications) {
    //           return findCartError(o);
    //         }

    //         return defaultMessage;
    //       }
    //       default:
    //         return defaultMessage;
    //     }
    //   });
  }
}

async function updateReqReorderInstallment(params) {
  try {
    log("OrderAPI::updateReqReorderInstallment", params);

    const orderToken = store.getters["order/orderToken"];
    const ssoToken = store.getters["ssoToken"];

    const headers = {
      "Sso-Token": ssoToken,
      "Order-Token": orderToken,
    };
    console.log(1152, params)
    const { result } = await http.post(
      "/order/payment",
      {
        search_type: "RIU",
        abo_no: store.getters.userId,
        cuid: store.getters.cuid,

        req_no: params.reqNo,
        abc_cd: params.abcCd,
        cfm_kind: params.cfmKind,
        delivery_address: params.deliveryAddress,
        delivery_message: params.deliveryMessage
      },
      headers
    );

    return result;
  } catch (e) {
    store.dispatch("newError", {
      msg: "오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
      error: e,
    });
    return {
      error: e,
    };
  }
}

async function changeBillingDate(reqNo, billingDate) {
  try {
    const result = await http.post('/order/modify-billing-date', {
      billing_date: billingDate,
      req_no: reqNo,
    });
    return result.result;
  } catch (e) {
    store.dispatch('newError', {
      msg: '정기 결제일을 변경 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.',
      error: e,
    });
    return {
      error: 'error',
    };
  }
}
export default {
  getPreOrderInfo,
  getPreOrderInfoForGroup,
  doOrder,
  checkAutoWithdrawPassword,
  getDeliveryList,
  cancelPayment,
  checkOrderLimit,
  changeDeliveryDestination,
  changePaymentMethod,
  checkSoldOut,
  removeSoldOut,
  getAmwayPayMethods,
  getAmwayPayClientKey,
  requestPayment,
  getOrderToken,
  getPaymentConfig,
  getBillingKeyInfo,
  getAboPhone,
  getAbcCd,
  placeOrder,
  updateReqReorderInstallment,
  changeBillingDate
};



// WEBPACK FOOTER //
// ./src/apis/order.js